import {
  type ColumnTitleProps,
  type ColumnType,
} from 'antd/es/table/interface';
import type React from 'react';
import { FlexRow } from '../../row/FlexRow.tsx';

export interface IColumnPickerHeaderCellProps<T> {
  column?: ColumnType<T>;
  titleProps?: ColumnTitleProps<T>;
  button?: React.ReactNode;
}
/**
 *
 */
export function ColumnPickerHeaderCell<T>(
  props: IColumnPickerHeaderCellProps<T>,
) {
  const { column, titleProps, button } = props;
  if (!column || !titleProps) return null;

  const titleBefore = column.title as JSX.Element;

  return <FlexRow right={button}>{titleBefore}</FlexRow>;
}
